import { render, staticRenderFns } from "./StepSummary.vue?vue&type=template&id=23c3e7f6&scoped=true&"
import script from "./StepSummary.vue?vue&type=script&lang=js&"
export * from "./StepSummary.vue?vue&type=script&lang=js&"
import style0 from "./StepSummary.vue?vue&type=style&index=0&id=23c3e7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c3e7f6",
  null
  
)

export default component.exports